import React from 'react';
import { Layout } from 'antd';
import EuropeanUnionLogo from 'assets/icons/EE_alone.png';
import { ReactComponent as EnvironmentLogo } from 'assets/icons/ministry-environment-icon-new.svg';
import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/government-greece-logo2.svg';
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import { ReactComponent as Tayped } from 'assets/icons/tayped_logo.svg';

const { Content } = Layout;

const Footer = () => {
  return (
    <div className="footer-container">
    <div className="footer-background"></div>
    <div className="footer-content">
    <div className="footer-logo">
      <img 
        src={EuropeanUnionLogo} className="eu-logo-size"  
      />
    </div>
      <div className="footer-logo">
        <GreenMinistryLogo className="clickable-element" onClick={() => window.open('https://ypen.gov.gr/', '_blank')}/>
      </div>
      <div className="footer-logo">
        <GreeceGovernmentLogo/>
      </div>
      {/* <div className="footer-logo">
        <Tayped/>
      </div> */}
    </div>
    <div className="footer-links">
      <span className="complaints-label">Για καταγγελίες ΤΑΑ:</span>
        <a
          href="https://greece20.gov.gr/kataggelies/"
          target="_blank"
          rel="noreferrer"
        >
          Καταγγελίες για έργα – Ελλάδα 2.0
        </a>
    </div>
  </div>
  );
};

export default Footer;
